var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cta-button-wrap mt-4"
  }, [_c('a', {
    staticClass: "cta-button rectangle text-lg text-center leading-4 tracking-wide font-semibold",
    style: _vm.styles,
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.text) + "\n\t")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };